import { Box } from '@mui/material'
import TruncatedText from '../../Common/TruncatedText'
import { useAppDispatch } from '../../../redux/hook'
import { updateViewTab } from '../../../redux/slices/entityViewSlice'
import { widgetView } from '../../../constants/constants'

interface AlarmStatusTypeDataPropsType {
    value: string
    fontSize?: string
    shouldUpdateTab?: boolean
}
const AlarmStatusTypeData: React.FC<AlarmStatusTypeDataPropsType> = ({
    value,
    fontSize,
    shouldUpdateTab = false,
}) => {
    const dispatch = useAppDispatch()

    return (
        <Box sx={{ width: '100%' }}>
            <Box
                onClick={
                    shouldUpdateTab
                        ? () => {
                              dispatch(updateViewTab(widgetView.ALERTS_VIEW))
                          }
                        : () => {}
                }
                sx={
                    shouldUpdateTab
                        ? { cursor: 'pointer', color: '#6d6dff' }
                        : {}
                }
            >
                <TruncatedText
                    sx={fontSize ? { fontSize } : undefined}
                    text={value}
                />
            </Box>
        </Box>
    )
}

export default AlarmStatusTypeData
